import { render, staticRenderFns } from "./InputEnum.vue?vue&type=template&id=b4123a34&"
import script from "./InputEnum.vue?vue&type=script&lang=ts&"
export * from "./InputEnum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports